import React, { useState } from "react";
import "./IpAddressManagement.scss";
import Header from "../Home/Header/Header";
import { CircularProgress } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ipList = [
  { ip: "192.168.1.100", status: "Available" },
  { ip: "192.168.1.101", status: "Assigned", device: "Printer Room" },
  { ip: "192.168.1.102", status: "In Use", device: "Server Room Switch" },
  { ip: "192.168.1.103", status: "Available" },
  { ip: "192.168.1.104", status: "Assigned", device: "Security Camera" },
  { ip: "192.168.1.105", status: "In Use", device: "Gateway Router" },
];

const recentChanges = [
  { text: "IP 192.168.1.101 assigned to Printer Room", time: "2h ago" },
  { text: "IP 192.168.1.102 status changed to In Use", time: "5h ago" },
];

const IpAddressManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIp, setSelectedIp] = useState(null);

  const handleSelect = (ip) => {
    setSelectedIp(ip);
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      )}
      <Header otherPage={true} title="IP Address Management" />
      <div className="ip-container">
        <div className="ip-body">
          <div className="network-status">
            <span className="wifi-icon">📶</span>
            <div>
              <p className="connected">Network Status: Connected</p>
              <p className="network-sub">
                Corporate Network - LAN 192.168.1.0/24
              </p>
            </div>
          </div>

          <RadioGroup
            value={selectedIp}
            onChange={(e) => handleSelect(e.target.value)}
          >
            {ipList.map(({ ip, status, device }) => (
              <div key={ip} className="ip-row">
                <FormControlLabel value={ip} control={<Radio />} label="" />
                <div className="ip-info">
                  <div className="ip-address">{ip}</div>
                  <div
                    className={`ip-status ${status
                      .toLowerCase()
                      .replace(" ", "-")}`}
                  >
                    {status}
                  </div>
                  {device && <div className="device-name">{device}</div>}
                </div>
                <ArrowForwardIosIcon className="arrow-icon" />
              </div>
            ))}
          </RadioGroup>

          <button className="update-ip-btn" disabled>
            Update IP
          </button>

          <div className="last-updated">
            <p>🕒 Last Updated: 2024-01-20 15:30</p>
            <p>Updated by: Admin.Smith</p>
          </div>

          <div className="recent-changes">
            <h4>Recent Changes</h4>
            {recentChanges.map((item, idx) => (
              <div key={idx} className="change-entry">
                <p>
                  {item.text} - <span>{item.time}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IpAddressManagement;
